import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import FileNameWithIcon from "../../../../components/fileNameWithIcon";
import Badges from "components/badege";
import useProfileHelper from "pages/profile/useProfileHelper";
import { useSelector } from "react-redux";
import {
  agreement30DaysType,
  agreementType,
  NDAType,
  SUBSTATUS_WAITING_FOR_OFFICIAL_NDA,
} from "utils/constantValues";

function NDAInformation() {
  const [t] = useTranslation();
  const { downloadFileInANewTab } = useProfileHelper();
  const userDetails = useSelector((state) => state.userDetails || {});

  const userFiles = Array.isArray(userDetails?.userFiles)
    ? userDetails.userFiles
    : [];
  const isValidFile = (file, type) =>
    Boolean(
      file?.id &&
        typeof file?.name === "string" &&
        file.name.trim() &&
        file.type === type
    );
  const NDA = userFiles.find((file) => isValidFile(file, NDAType));
  const agreement60DaysFiles = userFiles.filter((file) =>
    isValidFile(file, agreementType)
  );
  const agreement30DaysFiles = userFiles.filter((file) =>
    isValidFile(file, agreement30DaysType)
  );
  const showContractDays =
    agreement60DaysFiles.length > 0 && agreement30DaysFiles.length > 0;
  const contract60Label = showContractDays
    ? t("contract60Days")
    : t("contract");
  const contract30Label = showContractDays
    ? t("contract30Days")
    : t("contract");

  return (
    <div id="ndaSection" className="flex flex-wrap p-[24px] gap-[12px] self-stretch">
      <div className="flex items-start gap-6 self-stretch">
        <div className="flex flex-col items-start w-[330px] gap-3">
          <div className="flex items-center gap-2">
            <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
              {t("NDA")}
            </span>

            {[SUBSTATUS_WAITING_FOR_OFFICIAL_NDA].includes(
              userDetails?.subStatus
            ) ||
              (NDA?.name && (
                <Badges
                  label={NDA?.name ? "Signed" : "Pending"}
                  variant={NDA?.name ? "green" : "orange"}
                />
              ))}
          </div>
          {NDA?.name && (
            <div className="flex flex-wrap gap-[20px]">
              <FileNameWithIcon
                fileName={NDA?.name}
                showHover={true}
                withDelete={false}
                onDownloadHandler={() => downloadFileInANewTab(NDA?.id)}
              />
            </div>
          )}
        </div>
      </div>
      {agreement60DaysFiles.length > 0 && (
        <div className="flex items-start gap-6 self-stretch">
          <div className="flex flex-col items-start w-[330px] gap-3">
            <div className="flex items-center gap-2">
              <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
                {contract60Label}
              </span>
              <Badges label="Signed" variant="green" />
            </div>
            <div className="flex flex-col flex-wrap">
              {agreement60DaysFiles.map((file, index) => (
                <FileNameWithIcon
                  key={file.id}
                  fileName={file.name}
                  showHover={true}
                  onDownloadHandler={() => downloadFileInANewTab(file.id)}
                  withDelete={false}
                  withoutBorder={
                    agreement60DaysFiles.length === index + 1
                  }
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {agreement30DaysFiles.length > 0 && (
        <div className="flex items-start gap-6 self-stretch">
          <div className="flex flex-col items-start w-[330px] gap-3">
            <div className="flex items-center gap-2">
              <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
                {contract30Label}
              </span>
              <Badges label="Signed" variant="green" />
            </div>
            <div className="flex flex-col flex-wrap">
              {agreement30DaysFiles.map((file, index) => (
                <FileNameWithIcon
                  key={file.id}
                  fileName={file.name}
                  showHover={true}
                  withDelete={false}
                  onDownloadHandler={() => downloadFileInANewTab(file.id)}
                  withoutBorder={agreement30DaysFiles.length === index + 1}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

NDAInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default NDAInformation;
